var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tree',{ref:"dataTree",attrs:{"check-strictly":true,"data":_vm.treeData,"node-key":"id","props":_vm.props},on:{"node-click":_vm.handleClick}})}
var staticRenderFns = []

export { render, staticRenderFns }